import React, { Component, Fragment } from 'react';
import Dropdown from './dropdown';
import I18n from '~/utils/translations';

export default class MonthlyRentDropdown extends Component {
  constructor(props) {
    super(props);
  }

  get rentIncrement() {
    return [1000, 1500, 2000, 2500, 3000, 3500, 4000, 4500, 5000, 5500, 6000, 6500, 7000, 7500, 8000];
  }

  get currency() {
    var currencySymbol;
    if (this.props.city !== 'everywhere') {
      currencySymbol = this.props.city == 'london' ? '£' : '$';
    }
    return currencySymbol;
  }

  textFormatter = (i) => `${this.currency}${i.toLocaleString()}`;

  render() {
    return (
      <div className="preferences-pane rent-range-preferences">
        <span className="preferences-pane__title">{I18n.t('pages.homes.price_range_preferences.title')}</span>
        <div className="preferences-pane__dropdown-container">
          <Dropdown
            name="minRent"
            noneSelected="No Min"
            options={this.rentIncrement}
            value={this.props.minRent}
            max={this.props.maxRent}
            updateSelection={(e) => this.props.onMinRentChange(e.target.value)}
            optionTextFormatter={this.textFormatter}
          />
          <Dropdown
            name="maxRent"
            noneSelected="No Max"
            options={this.rentIncrement}
            value={this.props.maxRent}
            min={this.props.minRent}
            updateSelection={(e) => this.props.onMaxRentChange(e.target.value)}
            optionTextFormatter={this.textFormatter}
          />
        </div>
      </div>
    );
  }
}
